import { render } from "./OverlayHeader.vue?vue&type=template&id=b85eea62"
import script from "./OverlayHeader.vue?vue&type=script&lang=js"
export * from "./OverlayHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__